export const showMsg = () => {
  const browserhappy = document.getElementById('browserhappy');
  browserhappy.style.display = 'block';
};

export const removeHashFromUrl = () =>
  window.location.origin + window.location.pathname;

export const dybToB = (bankId) => (bankId === 'DYB' ? 'B' : bankId);
